module.exports = __webpack_public_path__ + "img/1504750740.d304041e.jpg";